<div style="border: solid 1px black;">
    <internal-tree-node *ngFor="let node of dataSource" [node]="node" [template]="nodeTemplate">
    </internal-tree-node>
</div>